import type { ThemeTemplate } from './templates';

export const templateB: ThemeTemplate = {
  id: 'B',
  name: '马蜂窝旅行风',
  layoutMode: 'mafengwo',
  tagline: '发现世界的另一种方式 · 和团队一起出发',
  description: '大面积封面图 · 横向滚动目的地 · 笔记式卡片 · 清新活泼',
  primary: '#FF6B35',
  accent: '#00A699',
  background: '#FFFFFF',
  secondary: '#FFF8F0',
  textPrimary: '#2D3436',
  textSecondary: '#636E72',
  heroGradient: 'linear-gradient(135deg, rgba(255,107,53,0.05) 0%, rgba(0,166,153,0.08) 100%)',
  cardBg: '#FFFFFF',
  cardBorderRadius: 16,
  buttonBorderRadius: 24,
  buttonStyle: 'pill',
  fontFamily: '"Noto Sans SC", "PingFang SC", -apple-system, sans-serif',
  navBg: 'rgba(255,255,255,0.98)',
  navText: '#2D3436',
  footerBg: '#2D3436',
  footerText: '#B2BEC3',
  preview: { primary: '#FF6B35', accent: '#00A699', background: '#FFFFFF' },
};
